import { SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <div className="flex flex-col gap-4 p-4">
      <SkeletonBlock className="h-10 w-full" />
      <SkeletonBlock className="h-10 w-full" />
      <SkeletonBlock className="h-10 w-full" />
    </div>
  )
}
